import type { RenamePlan } from '@cli-types/core-engine/snapshots.js'
import type { Node } from 'ts-morph'
import { getJsxAttributeName } from './get-jsx-attribute-name.js'
import { getPropertyNameForInitializer } from './get-property-name-for-initializer.js'
import { replacePathSegments } from './replace-path-segments.js'

export function replaceStringLiteralValue(
  value: string,
  filePath: string,
  node: Node,
  plan: RenamePlan
): string {
  let next = value

  for (const rename of plan.fields) {
    const jsxAttribute = getJsxAttributeName(node)
    const propertyName = getPropertyNameForInitializer(node)
    const isFieldPathLiteral =
      jsxAttribute === 'name' ||
      jsxAttribute === 'id' ||
      jsxAttribute === 'htmlFor' ||
      propertyName === 'accessorKey' ||
      propertyName === 'id' ||
      propertyName === 'name'

    if (isFieldPathLiteral) {
      next = replacePathSegments(next, rename.before, rename.after)
      continue
    }

    if (next === rename.before) {
      next = rename.after
      continue
    }

    if (next === `${rename.before}Html`) {
      next = `${rename.after}Html`
    }
  }

  for (const rename of plan.customCells) {
    if (filePath !== rename.columnsPath) {
      continue
    }

    if (next === `./cells/${rename.before}`) {
      next = `./cells/${rename.after}`
    }
  }

  return next
}
